import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

const WarningToast = ({ message, icon, duration = 2500, onClose }) => {
    useEffect(() => {
        const timer = setTimeout(() => {
            onClose(); // Auto-close after the given duration
        }, duration);

        return () => clearTimeout(timer); // Cleanup on unmount
    }, [duration, onClose]);

    return (
        <div className="toast-container toast-warning">
            <div className="toast-content">
                <div className="toast-icon">
                    <img
                        src={icon ? icon : 'https://cdn-icons-png.flaticon.com/512/463/463612.png'}
                        alt="Error"
                    />
                </div>
                <div className="toast-message">{message}</div>
            </div>
            <div className="toast-effect"></div>
        </div>
    );
};

WarningToast.propTypes = {
    message: PropTypes.string.isRequired,
    duration: PropTypes.number,
    onClose: PropTypes.func.isRequired,
};

export default WarningToast;
